import { useMutation as n } from "@tanstack/react-query";
import s from "../../helpers/service-helper.js";
import { isArrayWithItems as c } from "../../helpers/array-helper.js";
import "react/jsx-runtime";
import "dayjs";
import { arrayBufferToBase64 as u } from "../../helpers/file-helper.js";
const i = async (t) => {
  let e;
  return c(t) && (e = await Promise.all(
    t.map(async (o) => {
      const r = await o.arrayBuffer(), a = u(r);
      return {
        fileName: o.name,
        content: a,
        contentType: o.type
      };
    })
  )), e || [];
}, f = () => n({
  mutationKey: ["post-customer-service-company-service-now"],
  mutationFn: async (t) => {
    const e = await i(t.attachedFiles), o = {
      ...t,
      attachedFiles: e
    }, r = JSON.stringify(o);
    return s.httpPost("/v1/servicenow/business-customer/case", {
      body: r,
      headers: {
        "Content-Type": "application/json"
      }
    });
  },
  throwOnError: !1,
  retry: !1
}), h = () => n({
  mutationKey: ["post-customer-service-consumer-service-now"],
  mutationFn: async (t) => {
    const e = await i(t.attachedFiles), o = {
      ...t,
      attachedFiles: e
    }, r = JSON.stringify(o);
    return s.httpPost("/v1/servicenow/private-customer/case", {
      body: r,
      headers: {
        "Content-Type": "application/json"
      }
    });
  },
  throwOnError: !1,
  retry: !1
}), w = () => n({
  mutationKey: ["post-edi-invoice"],
  mutationFn: async (t) => {
    const e = JSON.stringify(t);
    return s.httpPost("/v1/servicenow/edi-invoice/case", {
      body: e,
      headers: {
        "Content-Type": "application/json"
      }
    });
  },
  throwOnError: !1,
  retry: !1
}), S = () => n({
  mutationKey: ["post-complaint"],
  mutationFn: async (t) => {
    const e = JSON.stringify(t);
    return s.httpPost("/v1/servicenow/complaint/case", {
      body: e,
      headers: {
        "Content-Type": "application/json"
      }
    });
  },
  throwOnError: !1,
  retry: !1
});
export {
  S as usePostComplaintServiceNow,
  f as usePostCustomerServiceCompanyServiceNow,
  h as usePostCustomerServiceConsumerServiceNow,
  w as usePostEdiInvoiceServiceNow
};
